import { defineStore } from 'pinia'
// ai主播列表的store 
export const anchorsListStore = defineStore('anchorsList', {
  state: () => ({
    list:[],
    state: false
  }),
  getters: {
    getList: (state) => {
      return state.list
    }
  },
  actions: {
    setList(list){
      this.list = list;
      this.state = true
    }
  },
});